import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import FloatingHelpButton from '../components/landing/FloatingHelpButton';
import ChatWidget from '../components/ChatWidget/ChatWidget';
import './LegalPage.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost/ehaazri/api';

// last_updated_at is a "YYYY-MM-DD HH:MM:SS" DB timestamp - take the date part
// literally (no Date() timezone parsing) so the displayed day never shifts
// depending on the viewer's or server's timezone.
const formatLastUpdated = (value) => {
  const match = (value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) {
    return new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }
  const [, year, month, day] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
};

const PrivacyPolicy = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchPageContent();
  }, []);

  const fetchPageContent = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/landing_page_api.php/pages/privacy_policy`);
      if (response.data.status === 'success') {
        setPageData(response.data.data);
      }
    } catch (error) {
      console.error('Failed to load page content:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderSection = (section) => {
    return (
      <section key={section.id} className="legal-section">
        <h2>{section.section_title}</h2>
        <div dangerouslySetInnerHTML={{ __html: section.section_content }} />
      </section>
    );
  };

  if (loading) {
    return (
      <div className="legal-page">
        <Header />
        <div className="loading-container" style={{ minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="legal-page">
      <Header />

      <div className="legal-hero">
        <div className="container">
          <h1>{pageData?.page_title || 'Privacy Policy'}</h1>
          <p>Last updated: {formatLastUpdated(pageData?.last_updated_at)}</p>
        </div>
      </div>

      <div className="legal-content">
        <div className="container">
          {pageData?.sections && pageData.sections.length > 0 ? (
            pageData.sections.map(renderSection)
          ) : (
            <>
              <section className="legal-section">
                <h2>Introduction</h2>
                <p>
                  Welcome to eHaazri. We respect your privacy and are committed to protecting your personal data.
                  This privacy policy will inform you about how we look after your personal data when you visit
                  our website or use our services and tell you about your privacy rights and how the law protects you.
                </p>
              </section>

              <section className="legal-section">
                <h2>Information We Collect</h2>
                <h3>Personal Information</h3>
                <p>We may collect the following types of personal information:</p>
                <ul>
                  <li>Identity Data: Name, username, job title</li>
                  <li>Contact Data: Email address, phone number, business address</li>
                  <li>Technical Data: IP address, browser type, device information</li>
                  <li>Usage Data: Information about how you use our website and services</li>
                  <li>Biometric Data: Facial recognition data for attendance verification (with explicit consent)</li>
                  <li>Location Data: GPS coordinates when marking attendance (with permission)</li>
                </ul>
              </section>

              <section className="legal-section">
                <h2>Contact Us</h2>
                <p>
                  If you have any questions about this privacy policy or our data practices, please contact us:
                </p>
                <ul>
                  <li>Email: privacy@ehaazri.com</li>
                  <li>Website: Use our Contact Support form</li>
                </ul>
              </section>
            </>
          )}
        </div>
      </div>

      <Footer />
      <FloatingHelpButton />
      <ChatWidget />
    </div>
  );
};

export default PrivacyPolicy;
